/**
 * Neutralizes CSV/spreadsheet formula injection: a string starting with
 * "=", "+", "-", "@", a tab, or a carriage return is interpreted as a
 * formula by Excel/Sheets/LibreOffice when the CSV is opened. Prefixing
 * with a leading single quote forces the cell to be read as plain text.
 */
export function neutralizeCsvInjection(value: string): string {
  return /^[=+\-@\t\r]/.test(value) ? `'${value}` : value;
}

/**
 * Escapes a single CSV field: injection-neutralizes string values, then
 * quotes the field (doubling any embedded quotes) whenever it contains a
 * comma, quote, or newline. Only strings can encode a formula, so
 * non-string values (numbers, booleans) are stringified without the
 * injection guard - applying it unconditionally would corrupt a value like
 * a negative number into text.
 */
export function escapeCsvField(value: unknown): string {
  if (value === undefined || value === null) return "";
  const str = typeof value === "string" ? neutralizeCsvInjection(value) : String(value);
  return /[",\r\n]/.test(str) ? `"${str.replace(/"/g, '""')}"` : str;
}
